<template>
    <el-config-provider :locale="locale" :size="config.size" :zIndex="config.zIndex" :button="config.button">
        <router-view></router-view>
    </el-config-provider>
</template>
<script>
    import { getCurrentInstance, defineComponent, ref, inject, provide, reactive, toRaw, watch, computed } from 'vue'
    import Api from '@/config/api'
    import { useUserStore, useOtherStore, useNavlistStore } from '@/store'
    import Cache from '@/utils/cache'
    import colorTool from '@/utils/color'
    import C from '@/config'
    import { getNavList } from '@/utils/function'

    export default defineComponent({
        components: {
        },
        setup(props, context) {
            const StoreUser = useUserStore()
            const StoreOther = useOtherStore()
            const StoreNavlist = useNavlistStore()
            const { proxy } = getCurrentInstance()
            const refreshToken = computed(() => StoreOther.refreshToken)
            const refreshConfig = computed(() => StoreOther.refreshConfig)
            const refreshMenus = computed(() => StoreOther.refreshMenus)

            setInterval(function() {
                let time = Date.parse(new Date()) / 1000
                let is_login = StoreUser.inspectLoginState()
                if (is_login && time > StoreUser.tokenExpiresTime - 600) {
                    getToken()
                }
            }, 1000)

            const config = ref({
                size: 'default',
                zIndex: 2000,
                button: {
                    autoInsertSpace: false
                }
            })
            const getToken = () => {
                proxy.jiu.request(Api.AdminPublicsRefresh).then((res, rej) => {
                    StoreUser.login(res.data)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                    StoreUser.logout()
                })
            }
            watch(
                () => refreshToken.value,
                (newv, oldv) => {
                    if (newv > oldv) {
                        getToken()
                    }
                }
            )
            watch(
                () => refreshConfig.value,
                (newv, oldv) => {
                    if (newv > oldv) {
                        console.log(newv, oldv)
                    }
                }
            )
            watch(
                () => refreshMenus.value,
                (newv, oldv) => {
                    if (newv > oldv) {
                        Cache.del('navList')
                        getNavList(StoreNavlist, 1)
                    }
                }
            )

            const app_color = C.COLOR || Cache.get('APP_COLOR')
            if (app_color) {
                document.documentElement.style.setProperty('--el-color-primary', app_color)
                for (let i = 1; i <= 9; i++) {
                    document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(app_color, i / 10))
                }
                for (let i = 1; i <= 9; i++) {
                    document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(app_color, i / 10))
                }
            }

            return {
                config
            }
        }
    })
</script>
<style lang="scss">
    @import '@/assets/css/style.scss';
</style>
